let swiper;
let lastActiveIndex = 0;

function initSwiper() {
  swiper = new Swiper(".swiper", {
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 3,

    spaceBetween: 0,
    allowTouchMove: true,
    preventInteractionOnTransition: false,
    allowSlideNext: true,
    allowSlidePrev: true,
    longSwipesRatio: 0.05,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      waitForTransition: false,
    },
    speed: 2000,
    effect: "slide",
    grabCursor: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    updateOnWindowResize: true,
    watchOverflow: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    ResizeObserver: true,
    resizeFix: true,
    mousewheel: { forceToAxis: true, sensitivity: 3 },
    keyboard: { enabled: true, onlyInViewport: true },
    navigation: {
      nextEl: ".slider-btn-next",
      prevEl: ".slider-btn-prev",
      lockClass: "none",
    },

    on: {
      init: function () {
        updateCaption(this);
        lastActiveIndex = this.realIndex;
      },
      slideChange: function () {
        updateCaption(this);
        lastActiveIndex = this.realIndex;
      },
    },
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initSwiper();

  window.addEventListener("resize", () => {
    if (swiper && typeof lastActiveIndex === "number") {
      swiper.update();
      swiper.slideToLoop(lastActiveIndex);
    }
  });
});

function updateCaption(swiperInstance) {
  const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
  const captionTitle = document.querySelector(".hero__caption-title");
  const captionSubtitle = document.querySelector(".hero__caption-subtitle");

  if (activeSlide && captionTitle && captionSubtitle) {
    captionTitle.textContent =
      activeSlide.getAttribute("data-title") || "Untitled";
    captionSubtitle.textContent =
      activeSlide.getAttribute("data-subtitle") || "";
  }
}
